import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./markdown.module.css";

// Raw HTML in the agent's text is never rendered — react-markdown escapes it by default, and
// nothing here turns that off. Links open in a new tab so the chat is never navigated away.
const components: Components = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noreferrer noopener">
      {children}
    </a>
  ),
};

/** `streaming` adds a soft, pulsing caret after the last line while text is still arriving. */
export function Markdown({ children, streaming = false }: { children: string; streaming?: boolean }) {
  return (
    <div className={`${styles.markdown} ${streaming ? styles.streaming : ""}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
